import { apiHost } from '@libs/providers/api-host.provider';
import { LeadMagnetStories } from '@models/leadmagnet.types';
import { recaptchaToken } from '@libs/integrations/grecaptcha';
import { findOrCreateVisitorSession, getVisitorSecret } from '@libs/utils/visitor.utils';

type LeadMagnetPayload = {
  firstName: string;
  lastName: string;
  email: string;
  story: LeadMagnetStories;
  company?: string;
  answers?: Record<string, string>;
  flags?: Record<string, boolean>;
};

export const createLeadMagnet = async (values: LeadMagnetPayload): Promise<string> => {
  const url = `${apiHost()}/web/leadmagnets`;
  const recaptcha = await recaptchaToken();
  const payload = {
    ...values,
    gRecaptcha: recaptcha,
    visitorSecret: getVisitorSecret(),
    visitorSession: findOrCreateVisitorSession(),
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await response.json();

  return data.id;
};
